<!-- uniapp vue2 markdown解析 -->
<template>
  <view class="ua__markdown" :class="[deviceInfo.isMobile && 'is_mobile']">
    <!--    <rich-text-->
    <!--      space="nbsp"-->
    <!--      :nodes="parseNodes(source)"-->
    <!--      @itemclick="handleItemClick"-->
    <!--      class="md_inc_dom"-->
    <!--      :id="richTextId"-->
    <!--      v-if="!isIncreatementMode"-->
    <!--    ></rich-text>-->
    <div
      v-html="parseNodes(source)"
      @itemclick="handleItemClick"
      class="md_inc_dom"
      :id="richTextId"
      v-if="!isIncreatementMode"
      space="nbsp"
    ></div>
    <div
      v-show="isIncreatementMode"
      :id="incMdId"
      ref="markdownIncrementDomRef"
      class="md_inc_dom"
    ></div>
    <iframeDialogVue
      ref="iframeDialogRef"
      :htmlContent="htmlContent"
      v-if="false"
    ></iframeDialogVue>
    <!--  -->
  </view>
</template>

<script>
import * as IncrementalDOM from "./lib/incrementalDom.0.7.0.min.js";
import MarkdownIt from "./lib/markdown-it.13.0.2.min.js";
import MarkdownItIncrementalDOM from "./lib/markdown-it-incremental-dom-v2.1.0.js";
import hljs from "./lib/highlight/uni-highlight.min.js";
import "./lib/highlight/atom-one-dark.css";
import parseHtml from "./lib/html-parser.js";
// import mk from "markdown-it-katex";
import useDeviceEnv from "@/views/Home/useData/useDeviceEnv/useDeviceEnv";
import iframeDialogVue from "./iframeDialog.vue";
import { createHash } from "crypto";
const { deviceInfo } = useDeviceEnv();
export default {
  components: {
    iframeDialogVue,
  },
  props: {
    source: String,
    showLine: { type: [Boolean, String], default: true },
    isDone: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      HTML_PREFIX: "html-prefix-",
      mdMap: new Map(),
      htmlContent: "",
      richTextId: "markdown_rich_text" + Math.random(),
      incMdId: "markdown-increment-dom" + Math.random(),
      markdownIncrementDomRef: null,
      deviceInfo,
      markdown: null,
      copyCodeData: [],
      MAX_CHANGE_TO_INCREATEMENT: 1500,
    };
  },
  computed: {
    isIncreatementMode() {
      return this.source?.length > this.MAX_CHANGE_TO_INCREATEMENT;
    },
  },
  watch: {
    source: {
      handler(value) {
        this.parseNodes(value);
      },
      immediate: true,
    },
  },
  mounted() {
    let that = this;
    let tempData = [];
    // const md = new MarkdownIt().use(MarkdownItIncrementalDOM, IncrementalDOM);
    this.markdown = new MarkdownIt({
      // 不设置为true，导致可以运行script标签
      html: false,
      linkify: false,
      highlight: function (str, lang) {
        let preCode = "";
        try {
          preCode = hljs.highlightAuto(str).value;
        } catch (err) {
          preCode = that.markdown.utils.escapeHtml(str);
        }
        const lines = preCode.split(/\n/);
        // 添加自定义行号
        let html = lines
          .map((item, index) => {
            if (item == "") {
              return "";
            }
            return (
              '<li><span class="line-num" data-line="' +
              (index + 1) +
              '"></span>' +
              item +
              "</li>"
            );
          })
          .join("");
        if (that.showLine) {
          html = '<ol style="padding: 0px 30px;">' + html + "</ol>";
        } else {
          html =
            '<ol style="padding: 0px 7px;list-style:none;">' + html + "</ol>";
        }
        tempData.push(str);
        that.copyCodeData = tempData;
        let htmlCode = `<div class="markdown-wrap">`;
        // 运行 html 代码的 dom 元素
        const runHtmlDiv = that.htmlCodeRunDiv(lang, str);
        // #ifndef MP-WEIXIN
        htmlCode += `<div style="color: #aaa;text-align: right;font-size: 12px;padding:8px;">`;
        htmlCode += `${lang}<a class="copy-btn" data-copy-index="${
          tempData.length - 1
        }" code-data-index="${
          tempData.length - 1
        }" style="margin-left: 8px;" >复制代码</a>`;
        htmlCode += `</div>`;
        // #endif

        htmlCode += `<pre class="hljs" style="padding:10px 8px 0;margin-bottom:5px;overflow: auto;display: block;border-radius: 5px;"><code>${html}${runHtmlDiv}</code></pre>`;
        htmlCode += "</div>";
        let loading =
          ' <span class="flicker size-8 rounded-full inline-block my-auto ml-10"></span>';
        htmlCode = htmlCode.replace(that.createRegular("dsLoading"), loading);
        return htmlCode;
      },
    }).use(MarkdownItIncrementalDOM, IncrementalDOM);
    this.parseNodes(this.source);
    const incrementDom = document.getElementById(this.incMdId);
    const richTextDom = document.getElementById(this.richTextId);
    if (richTextDom) {
      richTextDom.addEventListener("click", this.mdClick);
    }
    if (incrementDom) {
      incrementDom.addEventListener("click", this.mdClick);
    }
  },
  methods: {
    previewHtml(el) {
      const classNames = el?.className.split(" ") || [];
      if (classNames.some((item) => item.includes(this.HTML_PREFIX))) {
        const classHash = classNames.find((item) =>
          item.includes(this.HTML_PREFIX)
        );
        const html = this.mdMap.get(classHash);
        this.htmlContent = html;
        this.$refs?.iframeDialogRef.show();
        return true;
      }
      return null;
    },
    mdClick(e) {
      const el = e.target;
      const dataset = el?.dataset;
      if (!el || !dataset) return;
      // 处理 查看 html 内容的函数
      if (this.previewHtml(el)) return;
      if (el.dataset.hasOwnProperty("copyIndex")) {
        const codeDataIndex = el.dataset.copyIndex;
        uni.setClipboardData({
          data: this.copyCodeData[codeDataIndex],
          showToast: false,
          success() {
            uni.showToast({
              title: "复制成功",
              icon: "none",
            });
          },
        });
      }
      el.dataset;
    },
    getHash(input, length = 10) {
      return createHash("sha256").update(input).digest("hex").substr(0, length);
    },
    htmlCodeRunDiv(lang, htmlCode) {
      let runHtmlDiv = ``;
      if (lang === "html") {
        const hash = this.getHash(htmlCode);
        let classHash = `${this.HTML_PREFIX}${hash}`;
        this.mdMap.set(classHash, htmlCode);
        runHtmlDiv = `
        <div class="run-html-code ${classHash}" data-run-html-code="true">
          <div class="flex ${classHash}">
            <div class="play-button ${classHash}"></div>
            <div class="${classHash}">运行 HTML</div>
          </div>
        </div>`;
      }
      return runHtmlDiv;
    },
    createRegular(txt) {
      return new RegExp(txt, "g");
    },
    parseNodes(value) {
      if (!value) return;
      if (!this.markdown) return;
      // 解析<br />到\n
      value = value.replace(this.createRegular("<br>|<br\/>|<br \/>"), "\n");
      value = value.replace(this.createRegular("&nbsp;"), " ");
      const isIncreatementMode = value.length > this.MAX_CHANGE_TO_INCREATEMENT;
      if (isIncreatementMode) {
        value = value.replace(this.createRegular("dsLoading"), "");
      }
      let htmlString = "";
      if (value.split("\`\`\`").length % 2) {
        let mdtext = value;
        if (mdtext[mdtext.length - 1] != "\n") {
          mdtext += "\n";
        }
        // const t = `1. **HTML结构**\n   - 首先创建一个简单的HTML结构来应用CSS样式。\n   \`\`\`html\n   <!DOCTYPE html>\n   <html lang="en">\n\n   <head>\n       <meta charset="UTF - 8">\n       <meta name="viewport" content="width=device-width, initial-scale = 1.0">\n       <link rel="stylesheet" href="styles.css">\n       <title>CSS样式示例</title>\n   </head>\n\n   <body>\n       <div class="fade - out - element">\n           这是一个带有淡出效果的元素\n       </div>\n       <div class="colored - element">\n           这是一个有背景颜色的元素\n       </div>\n   </body>\n\n   </html>\n   \`\`\`\n2. **CSS样式（styles.css）**\n   - **淡出效果（fade - out）**\n     - 可以使用\`opacity\`属性和\`transition\`属性来实现淡出效果。\n     \`\`\`css\n     /* 淡出效果类 */\n    .fade - out - element {\n         opacity: 1;\n         transition: opacity 2s ease - in - out;\n     }\n    .fade - out - element:hover {\n         opacity: 0;\n     }\n     \`\`\`\n   - **背景颜色（background - color）**\n     - 简单地设置\`background - color\`属性来改变元素的背景颜色。\n     \`\`\`css\n     /* 背景颜色类 */\n    .colored - element {\n         background - color: lightblue;\n         padding: 20px;\n         border: 1px solid gray;\n     }\n     \`\`\`\n\n在上述代码中：\n- 对于\`fade - out - element\`类：\n    - 初始\`opacity\`为1，表示完全不透明。\n    - 当鼠标悬停（\`:hover\`）在元素上时，\`opacity\`在2秒内平滑地变为0，实现淡出效果。\n- 对于\`colored - element\`类：\n    - 元素的背景颜色被设置为淡蓝色（\`lightblue\`），并且添加了一些内边距（\`padding\`）和边框（\`border\`）来使效果更明显。`
        // const t = `1. **HTML结构**\n   - 首先创建一个简单的HTML结构来应用CSS样式。\n   \`\`\`html\n   <!DOCTYPE html>\n   <html lang="en">\n\n   <head>\n       <meta charset="UTF - 8">\n       <meta name="viewport" content="width=device-width, initial-scale = 1.0">\n       <link rel="stylesheet" href="styles.css">\n       <title>CSS样式示例</title>\n   </head>\n\n   <body>\n       <div class="fade - out - element">\n           这是一个带有淡出效果的元素\n       </div>\n       <div class="colored - element">\n           这是一个有背景颜色的元素\n       </div>\n   </body>\n\n   </html>\n   \`\`\`\n2. **CSS样式（styles.css）**\n   - **淡出效果（fade - out）**\n     - 可以使用\`opacity\`属性和\`transition\`属性来实现淡出效果。\n     \`\`\`css\n     /* 淡出效果类 */\n     .fade - out - element {\n         opacity: 1;\n         transition: opacity 2s ease - in - out;\n     }\n     .fade - out - element:hover {\n         opacity: 0;\n     }\n     \`\`\`\n   - **背景颜色（background - color）**\n     - 简单地设置\`background - color\`属性来改变元素的背景颜色。\n     \`\`\`css\n     /* 背景颜色类 */\n    .colored - element {\n         background - color: lightblue;\n         padding: 20px;\n         border: 1px solid gray;\n     }\n     \`\`\`\n\n在上述代码中：\n- 对于\`fade - out - element\`类：\n    - 初始\`opacity\`为1，表示完全不透明。\n    - 当鼠标悬停（\`:hover\`）在元素上时，\`opacity\`在2秒内平滑地变为0，实现淡出效果。\n- 对于\`colored - element\`类：\n    - 元素的背景颜色被设置为淡蓝色（\`lightblue\`），并且添加了一些内边距（\`padding\`）和边框（\`border\`）来使效果更明显。`
        // mdtext = this.fixCodeIndent(t)
        mdtext = this.fixCodeIndent(mdtext);
        // console.log('mdtext', [mdtext]);
        // 原文（错误格式）
        // mdtext = `2. **CSS样式（调整）**\n   - 为了处理负值，我们可以修改数据条的样式，使其能够以不同的颜色显示正值和负值。\n   \`\`\`css\n  .data - bar {\n       height: 20px;\n       display: inline - block;\n     }\n  .data - bar.positive {\n       background - color: lightblue;\n     }\n  .data - bar.negative {\n       background - color: lightcoral;\n       /* 对于负值，我们可以让它从右向左显示，这里使用绝对定位来实现 */\n       position: relative;\n       left: 100%;\n       margin - left: -100%;\n     }\n   \`\`\`\n3. **JavaScript实现（调整）**\n   - 在JavaScript中，我们需要根据数值的正负来添加不同的类名，并正确计算宽度。\n   \`\`\`javascript\n   window.onload = function () {\n     var table = document.getElementById('myTable');\n     var rows = table.getElementsByTagName('tr');\n     for (var i = 1; i < rows.length; i++) {\n       var cell = rows[i].getElementsByTagName('td')[1];\n       var value = parseInt(cell.getAttribute('data - value'));\n       var bar = document.createElement('div');\n       bar.className = 'data - bar';\n       if (value >= 0) {\n         bar.className +='positive';\n         bar.style.width = value + '%';\n       } else {\n         bar.className +='negative';\n         // 对于负值，取其绝对值来计算宽度\n         bar.style.width = Math.abs(value)+ '%';\n       }\n       cell.appendChild(bar);\n     }\n   };\n   \`\`\`\n`
        // 正确格式
        // mdtext = `2. **CSS样式（调整）**\n   - 为了处理负值，我们可以修改数据条的样式，使其能够以不同的颜色显示正值和负值。\n   \`\`\`css\n   .data - bar {\n       height: 20px;\n       display: inline - block;\n     }\n   .data - bar.positive {\n       background - color: lightblue;\n     }\n   .data - bar.negative {\n       background - color: lightcoral;\n       /* 对于负值，我们可以让它从右向左显示，这里使用绝对定位来实现 */\n       position: relative;\n       left: 100%;\n       margin - left: -100%;\n     }\n   \`\`\`\n3. **JavaScript实现（调整）**\n   - 在JavaScript中，我们需要根据数值的正负来添加不同的类名，并正确计算宽度。\n   \`\`\`javascript\n   window.onload = function () {\n     var table = document.getElementById('myTable');\n     var rows = table.getElementsByTagName('tr');\n     for (var i = 1; i < rows.length; i++) {\n       var cell = rows[i].getElementsByTagName('td')[1];\n       var value = parseInt(cell.getAttribute('data - value'));\n       var bar = document.createElement('div');\n       bar.className = 'data - bar';\n       if (value >= 0) {\n         bar.className +='positive';\n         bar.style.width = value + '%';\n       } else {\n         bar.className +='negative';\n         // 对于负值，取其绝对值来计算宽度\n         bar.style.width = Math.abs(value)+ '%';\n       }\n       cell.appendChild(bar);\n     }\n   };\n   \`\`\`\n`
        if (isIncreatementMode && this.$refs.markdownIncrementDomRef) {
          const func = this.markdown.renderToIncrementalDOM(mdtext);
          IncrementalDOM.patch(this.$refs.markdownIncrementDomRef, func);
          return;
        }
        htmlString = this.markdown.render(mdtext);
      } else {
        if (isIncreatementMode && this.$refs.markdownIncrementDomRef) {
          const func = this.markdown.renderToIncrementalDOM(value);
          IncrementalDOM.patch(this.$refs.markdownIncrementDomRef, func);
          return;
        }
        htmlString = this.markdown.render(value);
      }
      let loading =
        ' <span class="flicker size-8 rounded-full inline-block my-auto ml-10"></span>';
      htmlString = htmlString.replace(this.createRegular("dsLoading"), loading);
      // 解决小程序表格边框型失效问题
      htmlString = htmlString.replace(
        this.createRegular("<table"),
        `<table class="table"`
      );
      htmlString = htmlString.replace(
        this.createRegular("<tr"),
        `<tr class="tr"`
      );
      htmlString = htmlString.replace(
        this.createRegular("<th"),
        `<th class="th">`
      );
      htmlString = htmlString.replace(
        this.createRegular("<td"),
        `<td class="td"`
      );
      htmlString = htmlString.replace(
        this.createRegular("<hr>|<hr\/>|<hr \/>"),
        `<hr class="hr">`
      );
      // 判断htmlString是否有url链接 ,添加a标签跳转
      // 对已经渲染了的a标签，不处理

      //匹配兼容safiri浏览器的a标签的href属性的正则
      // 将/(?<!<a href=")(?:(?:https?|ftp):\/\/)[\w\-]+(\.[\w\-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?/g;转为new RegExp
      const reg =
        /(?:(?:https?|ftp):\/\/)[\w\-]+(\.[\w\-]+)+([\w.,@?^=%&:/~+#-]*[\w@?^=%&/~+#-])?((?!.*&quot;).)*/g;
      htmlString = htmlString.replace(reg, (val, ...args) => {
        const index = args[3];
        const inPre = this.findIndexIsPre(htmlString, index);
        if (inPre) {
          // 在 pre 标签中的不处理
          return val;
        }
        let isQuot = false;
        if (val.includes("&quot;")) {
          isQuot = true;
        }
        val = val.replace(/&quot;/g, "");
        const newVal = `<a href="${val}"`;
        if (htmlString.includes(newVal)) {
          return val;
        }
        return `<a href="${val}" target="_blank">${val}</a>${
          isQuot ? "&quot;" : ""
        }`;
      });
      // #ifndef APP-NVUE
      // console.log('htmlString', htmlString,);
      return htmlString;
      // #endif
      // 将htmlString转成htmlArray，反之使用rich-text解析
      // #ifdef APP-NVUE
      return parseHtml(htmlString);
      // #endif
    },
    fixCodeIndent(str = "") {
      const matches = str.matchAll(/\`\`\`/g);
      const matchesList = [];
      for (const match of matches) {
        matchesList.push(match.index);
      }
      const CODE_STATUS = {
        NONE: 0,
        START: 1,
        END: 2,
      };
      // 记录开始 \`\`\` 到 截止 \`\`\` 之前的 \n 后面都要保持至少3个空格，否则缩进不对
      matchesList.forEach((backquoteIndex, index) => {
        if (index % 2 === 0 && matchesList[index + 1]) {
          // 此处为开始的 \`\`\` 位置,并且有下一个 \`\`\` 存在
          let checkStr = str.slice(backquoteIndex + 3, matchesList[index + 1]);
          // console.log('checkStr', [checkStr]);
          const checkStrList = checkStr.split("");
          let indentCount = 0;
          let curStatus = CODE_STATUS.NONE;
          const firstEnterIndex = checkStrList.findIndex(
            (item) => item === "\n"
          );
          let minIndent = 0;
          let indentStart = firstEnterIndex + 1;
          // 找到第一个 \n 之后，记录下缩进空格，作为之后的最小缩进空格
          if (firstEnterIndex !== -1) {
            while (true) {
              if (checkStrList[indentStart++] === " ") {
                minIndent++;
              } else {
                break;
              }
            }
          }
          minIndent = Math.max(minIndent, 3);
          let i = 0;
          while (i < checkStrList.length) {
            const curI = i;
            const item = checkStrList[curI];
            i++;

            if (item === "\n") {
              curStatus = CODE_STATUS.START;
              continue;
            }
            if (curStatus === CODE_STATUS.START) {
              if (item === " ") {
                indentCount++;
              } else {
                curStatus = CODE_STATUS.END;
                // \n 后面都要保持至少 minIndent 个空格
                if (indentCount < minIndent) {
                  checkStrList.splice(
                    curI - 1,
                    0,
                    " ".repeat(minIndent - indentCount)
                  );
                }
                indentCount = 0;
              }
            }
          }
          let newStr =
            str.slice(0, backquoteIndex + 3) +
            checkStrList.join("") +
            str.slice(matchesList[index + 1]);
          str = newStr;
          // "2. **CSS样式（调整）**\n   - 为了处理负值，我们可以修改数据条的样式，使其能够以不同的颜色显示正值和负值。\n   ```css\n   .data - bar {\n       height: 20px;\n       display: inline - block;\n     }\n   .data - bar.positive {\n       background - color: lightblue;\n     }\n   .data - bar.negative {\n       background - color: lightcoral;\n       /* 对于负值，我们可以让它从右向左显示，这里使用绝对定位来实现 */\n       position: relative;\n       left: 100%;\n       margin - left: -100%;\n     }\n   ```\n3. **JavaScript实现（调整）**\n   - 在JavaScript中，我们需要根据数值的正负来添加不同的类名，并正确计算宽度。\n   ```javascript\n   window.onload = function () {\n     var table = document.getElementById('myTable');\n     var rows = table.getElementsByTagName('tr');\n     for (var i = 1; i < rows.length; i++) {\n       var cell = rows[i].getElementsByTagName('td')[1];\n       var value = parseInt(cell.getAttribute('data - value'));\n       var bar = document.createElement('div');\n       bar.className = 'data - bar';\n       if (value >= 0) {\n         bar.className +='positive';\n         bar.style.width = value + '%';\n       } else {\n         bar.className +='negative';\n         // 对于负值，取其绝对值来计算宽度\n         bar.style.width = Math.abs(value)+ '%';\n       }\n       cell.appendChild(bar);\n     }\n   };\n   ```\n"
          // `2. **CSS样式（调整）**\n   - 为了处理负值，我们可以修改数据条的样式，使其能够以不同的颜色显示正值和负值。\n   \`\`\`css\n   .data - bar {\n       height: 20px;\n       display: inline - block;\n     }\n   .data - bar.positive {\n       background - color: lightblue;\n     }\n   .data - bar.negative {\n       background - color: lightcoral;\n       /* 对于负值，我们可以让它从右向左显示，这里使用绝对定位来实现 */\n       position: relative;\n       left: 100%;\n       margin - left: -100%;\n     }\n   \`\`\`\n3. **JavaScript实现（调整）**\n   - 在JavaScript中，我们需要根据数值的正负来添加不同的类名，并正确计算宽度。\n   \`\`\`javascript\n   window.onload = function () {\n     var table = document.getElementById('myTable');\n     var rows = table.getElementsByTagName('tr');\n     for (var i = 1; i < rows.length; i++) {\n       var cell = rows[i].getElementsByTagName('td')[1];\n       var value = parseInt(cell.getAttribute('data - value'));\n       var bar = document.createElement('div');\n       bar.className = 'data - bar';\n       if (value >= 0) {\n         bar.className +='positive';\n         bar.style.width = value + '%';\n       } else {\n         bar.className +='negative';\n         // 对于负值，取其绝对值来计算宽度\n         bar.style.width = Math.abs(value)+ '%';\n       }\n       cell.appendChild(bar);\n     }\n   };\n   \`\`\`\n`
        }
      });
      return str;
    },
    findIndexIsPre(str = "", index = 0) {
      const indices = this.findPre(str);
      let isInPre = false;
      indices.forEach((item) => {
        const [strat, end] = item;
        if (index >= strat && index <= end) {
          isInPre = true;
        }
      });
      return isInPre;
    },
    findPre(str = "") {
      let indices = [];
      let index = str.indexOf("<pre");
      let lastIndex = str.lastIndexOf("/pre>");
      while (index !== -1) {
        indices.push([index, lastIndex]);
        index = str.indexOf("<pre", index + 1);
        lastIndex = str.slice(index, lastIndex).indexOf("/pre>");
      }
      return indices;
    },
    handleItemClick(e) {
      let { name, attrs } = e.detail.node;
      let { "code-data-index": codeDataIndex, class: className } = attrs;
      if (className == "copy-btn") {
        uni.setClipboardData({
          data: this.copyCodeData[codeDataIndex],
          showToast: false,
          success() {
            uni.showToast({
              title: "复制成功",
              icon: "none",
            });
          },
        });
      } else if (name == "a") {
        window.open(attrs.href, "_blank");
      }
    },
  },
};
</script>

<style lang="scss" scoped>
.ua__markdown {
  ::v-deep .md_inc_dom {
    &.is_mobile {
      ol,
      ul {
        padding-left: 16px;
      }
    }

    font-size: 15px;
    line-height: 1.5;
    word-break: break-all;

    a {
      cursor: pointer;
      color: #5e57ff !important;
    }

    h1,
    h2,
    h3,
    h4,
    h5,
    h6 {
      font-family: inherit;
      font-weight: 700;
      line-height: 1.1;
      color: inherit;
    }

    h1,
    h2,
    h3 {
      margin-top: 12px;
      margin-bottom: 8px;
    }

    h4,
    h5,
    h6 {
      margin-top: 10px;
      margin-bottom: 6px;
    }

    .h1,
    h1 {
      font-size: 22px;
    }

    .h2,
    h2 {
      font-size: 20px;
    }

    .h3,
    h3 {
      font-size: 18px;
    }

    .h4,
    h4 {
      font-size: 16px;
    }

    .h5,
    h5 {
      font-size: 14px;
    }

    .h6,
    h6 {
      font-size: 12px;
    }

    a {
      background-color: transparent;
      color: #2196f3;
      text-decoration: none;
    }

    hr,
    ::v-deep .hr {
      margin-top: 20px;
      margin-bottom: 20px;
      border: 0;
      border-top: 1px solid #e5e5e5;
    }

    img {
      max-width: 35%;
    }

    p {
      margin: 0;
    }

    em {
      font-style: italic;
      font-weight: inherit;
    }

    ol,
    ul {
      margin-top: 0;
      margin-bottom: 10px;
      padding-left: 30px;

      li {
        line-height: 1.5;
      }
    }

    ol ol,
    ol ul,
    ul ol,
    ul ul {
      margin-bottom: 0;
    }

    ol ol,
    ul ol {
      list-style-type: lower-roman;
    }

    ol ol ol,
    ul ul ol {
      list-style-type: lower-alpha;
    }

    dl {
      margin-top: 0;
      margin-bottom: 20px;
    }

    dt {
      font-weight: 600;
    }

    dt,
    dd {
      line-height: 1.4;
    }

    .task-list-item {
      list-style-type: none;
    }

    .task-list-item input {
      margin: 0 0.2em 0.25em -1.6em;
      vertical-align: middle;
    }

    pre {
      position: relative;
      z-index: 11;
      white-space: pre;
      padding-bottom: 10px;

      code {
        white-space: pre-wrap;
        word-break: break-word;
      }
    }

    code,
    kbd,
    pre,
    samp {
      font-family: Menlo, Monaco, Consolas, "Courier New", monospace;
    }
    pre code:not(.hljs) {
      color: inherit;
      background-color: inherit;
      color: inherit;
      background: inherit;
      font-size: 12px;
      padding: 0;
    }
    code:not(.hljs) {
      padding: 2px 4px;
      font-size: 90%;
      color: #c7254e;
      background-color: #ffe7ee;
      border-radius: 4px;
    }

    code:empty {
      display: none;
    }

    pre code.hljs {
      color: var(--vg__text-1);
      border-radius: 16px;
      background: var(--vg__bg-1);
      font-size: 12px;
    }

    .markdown-wrap {
      font-size: 12px;
      margin-bottom: 10px;
      .run-html-code {
        padding: 10px 14px;
        color: #fff;
        font-size: 12px;
        line-height: 12px;
        justify-content: flex-end;
        display: flex;
        cursor: pointer;
        .play-button {
          width: 0;
          height: 0;
          display: inline-block;
          border-style: solid;
          border-width: 6px 0 6px 12px; /* 上、右、下、左 */
          border-color: transparent transparent transparent #fff; /* 只有左边框有颜色 */
          cursor: pointer; /* 鼠标悬停时显示为手型 */
          margin-right: 6px;
        }
      }
    }

    pre.code-block-wrapper {
      background: #2b2b2b;
      color: #f8f8f2;
      border-radius: 4px;
      overflow-x: auto;
      padding: 1em;
      position: relative;
    }

    pre.code-block-wrapper code {
      padding: auto;
      font-size: inherit;
      color: inherit;
      background-color: inherit;
      border-radius: 0;
    }

    .code-block-header__copy {
      font-size: 16px;
      margin-left: 5px;
    }

    abbr[data-original-title],
    abbr[title] {
      cursor: help;
      border-bottom: 1px dotted #777;
    }

    blockquote {
      padding: 8px 16px;
      margin: 0 0 15px;
      border-left: 3px solid #e5e5e5;
      font-size: 13px;
      color: #858585;
      p {
        padding: 7px 0;
      }
      p:first-child {
        padding-top: 0;
      }
      p:last-child {
        padding-bottom: 0;
      }
    }

    blockquote ol:last-child,
    blockquote p:last-child,
    blockquote ul:last-child {
      margin-bottom: 0;
    }

    blockquote .small,
    blockquote footer,
    blockquote small {
      display: block;
      font-size: 80%;
      line-height: 1.42857143;
      color: #777;
    }

    blockquote .small:before,
    blockquote footer:before,
    blockquote small:before {
      content: "\2014 \00A0";
    }

    .blockquote-reverse,
    blockquote.pull-right {
      padding-right: 15px;
      padding-left: 0;
      text-align: right;
      border-right: 5px solid #eee;
      border-left: 0;
    }

    .blockquote-reverse .small:before,
    .blockquote-reverse footer:before,
    .blockquote-reverse small:before,
    blockquote.pull-right .small:before,
    blockquote.pull-right footer:before,
    blockquote.pull-right small:before {
      content: "";
    }

    .blockquote-reverse .small:after,
    .blockquote-reverse footer:after,
    .blockquote-reverse small:after,
    blockquote.pull-right .small:after,
    blockquote.pull-right footer:after,
    blockquote.pull-right small:after {
      content: "\00A0 \2014";
    }

    .footnotes {
      -moz-column-count: 2;
      -webkit-column-count: 2;
      column-count: 2;
    }

    .footnotes-list {
      padding-left: 2em;
    }

    table,
    ::v-deep .table {
      border-spacing: 0;
      border-collapse: collapse;
      width: 100%;
      max-width: 65em;
      overflow: auto;
      margin-top: 0;
      margin-bottom: 16px;
    }

    table tr,
    ::v-deep .table .tr {
      border-top: 1px solid #e5e5e5;
    }

    table th,
    table td,
    ::v-deep .table .th,
    ::v-deep .table .td {
      padding: 6px 13px;
      border: 1px solid #e5e5e5;
    }

    table th,
    ::v-deep .table .th {
      font-weight: 600;
      background-color: #eee;
    }

    .hljs[class*="language-"]:before {
      position: absolute;
      z-index: 3;
      top: 0.8em;
      right: 1em;
      font-size: 0.8em;
      color: #999;
    }

    .hljs[class~="language-js"]:before {
      content: "js";
    }

    .hljs[class~="language-ts"]:before {
      content: "ts";
    }

    .hljs[class~="language-html"]:before {
      content: "html";
    }

    .hljs[class~="language-md"]:before {
      content: "md";
    }

    .hljs[class~="language-vue"]:before {
      content: "vue";
    }

    .hljs[class~="language-css"]:before {
      content: "css";
    }

    .hljs[class~="language-sass"]:before {
      content: "sass";
    }

    .hljs[class~="language-scss"]:before {
      content: "scss";
    }

    .hljs[class~="language-less"]:before {
      content: "less";
    }

    .hljs[class~="language-stylus"]:before {
      content: "stylus";
    }

    .hljs[class~="language-go"]:before {
      content: "go";
    }

    .hljs[class~="language-java"]:before {
      content: "java";
    }

    .hljs[class~="language-c"]:before {
      content: "c";
    }

    .hljs[class~="language-sh"]:before {
      content: "sh";
    }

    .hljs[class~="language-yaml"]:before {
      content: "yaml";
    }

    .hljs[class~="language-py"]:before {
      content: "py";
    }

    .hljs[class~="language-docker"]:before {
      content: "docker";
    }

    .hljs[class~="language-dockerfile"]:before {
      content: "dockerfile";
    }

    .hljs[class~="language-makefile"]:before {
      content: "makefile";
    }

    .hljs[class~="language-javascript"]:before {
      content: "js";
    }

    .hljs[class~="language-typescript"]:before {
      content: "ts";
    }

    .hljs[class~="language-markup"]:before {
      content: "html";
    }

    .hljs[class~="language-markdown"]:before {
      content: "md";
    }

    .hljs[class~="language-json"]:before {
      content: "json";
    }

    .hljs[class~="language-ruby"]:before {
      content: "rb";
    }

    .hljs[class~="language-python"]:before {
      content: "py";
    }

    .hljs[class~="language-bash"]:before {
      content: "sh";
    }

    .hljs[class~="language-php"]:before {
      content: "php";
    }
  }
}

@keyframes flicker {
  0% {
    opacity: 0.8;
  }
  50% {
    opacity: 0.2;
  }
  100% {
    opacity: 0.8;
  }
}

::v-deep .flicker {
  background-color: #999;
  animation: flicker 0.5s infinite;
  width: 8px !important;
  height: 8px !important;
  border-radius: 4px;
  margin-left: 10px;
  display: inline-block;
}
</style>
